const IbkLoanClientBtmSheet = (props) =>{
    const {ibkLoanClientbtmSheet, setIbkLoanClientbtmSheet, ibkLoanBizNm, chkDuplication} = props;
    
    return(
        <div id="popBottomSheet" className={`layerPopWrap halflayerPop on ${ibkLoanClientbtmSheet ? 'on' : ''}`}>
            <div className="bg" onClick={()=>{setIbkLoanClientbtmSheet(false)}}></div>
            <div className="layerPopCont">
                <div className="contBox20 maxHScroll pt24">
                    <p className="normalTit txtKeepall">
                        IBK기업은행으로 서류를 제출할 사업자명을 확인해 주세요.
                    </p>
                    <p className="mediumTit txtBold txtCenter pt24">
                        {ibkLoanBizNm}
                    </p>
                </div>
                <div className="popBtnGroupWrap full flex">
                    {/* 비활성화  .on */}
                    <a className="btn btnPopClose" onClick={()=>{setIbkLoanClientbtmSheet(false)}}>취소</a>
                    <a className="btn btnPopClose on" onClick={()=>{chkDuplication()}}>확인</a>
                </div>
            </div>
        </div>
    )
}
export default IbkLoanClientBtmSheet;